import React from 'react';

import './styles.scss';
import { useIntl } from 'react-intl';

const RLMSDetails = () => {
  const intl = useIntl();
  return (
    <div>
      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.rateOverview',
          defaultMessage: 'Rate Overview',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `Earn a $25 one-time enrollment and $24 monthly participation incentive for charging within the convenience of your home during off-peak hours.`,
        })}
      </p>
      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.howItWorks',
          defaultMessage: 'How it Works',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `The EV Charge Smart Plan is a program that provides customers with financial incentives to charge during off-peak hours (11 p.m. to 7 a.m. est.) when there is less strain on the grid and energy costs are lower.`,
        })}
      </p>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `The program is administered through a user-friendly smart phone application, Charge Smart NY, available in Apple and GooglePlay App stores on your mobile device.`,
        })}
      </p>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `Eligibility: National Grid Upstate NY customers on the SC-1 residential rate with compatible equipment are eligible to participate in the program (list of supported vehicles and charging stations is available on the program website – link below).`,
        })}
      </p>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `One-time enrollment incentive will be awarded for actively participating in the program for a minimum of three (3) months.`,
        })}
      </p>
      <p className="text link">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `Monthly Participation Incentive is can be earned each calendar month. To earn the incentive, customers need to:`,
        })}
      </p>
      <ul>
        <li>
          {intl.formatMessage({
            id: 'rlms.vtou_overview_description',
            defaultMessage: `Charge a minimum of 50 kWh at-home and,`,
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'rlms.vtou_overview_description',
            defaultMessage: `80% or > of at-home charging occurs during off-peak hours`,
          })}
        </li>
      </ul>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `Earned incentives, both one-time and monthly participation, are applied as a credit to your bill.`,
        })}
      </p>
      <div>
        <p className="text link">
          {intl.formatMessage({
            id: 'rlms.vtou_overview_description',
            defaultMessage: `Learn more and enroll at`,
          })}
        </p>
        <a
          href="https://www.nationalgridus.com/electric-vehicle-hub/Programs/Charge-Smart-NY/"
          target="_blank"
          rel="noopener noreferrer"
          className="link-underline"
        >
          {intl.formatMessage({
            id: 'rlms.vtou_overview_description',
            defaultMessage: `National Grid - Charge Smart NY.`,
          })}
        </a>
      </div>
      <br />
      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.whatItMeans',
          defaultMessage: 'What it Means for You',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `Financial Savings: Save up to $288 annually in monthly incentives on your electricity costs by charging your EV in the convenience of your home during off-peak hours.`,
        })}
      </p>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `Simplicity: Optimize your charging performance by setting your vehicle schedule (Set it and Forget it) to efficiently manage your charging to reduce costs while tracking your usage.`,
        })}
      </p>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.vtou_overview_description',
          defaultMessage: `Positive Environmental Impact: Shift your at-home charging to off-peak hours positively impacting the environment in helping to further reduce grid emissions.`,
        })}
      </p>
      <a
        href="https://www.nationalgridus.com/electric-vehicle-hub/Programs/Charge-Smart-NY/"
        className="cta-btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({
          id: 'rateDetails.learnMore',
          defaultMessage: 'Learn More and Enroll in the EV Charge Smart Plan',
        })}
      </a>
    </div>
  );
};

export default RLMSDetails;
